import { Button, Modal } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

function SuccessModal({ show, message, onClose }) {
    const { t } = useTranslation('messages');
    return (
        <Modal show={show} onHide={onClose} centered size="sm">
            <Modal.Body className="p-0 overflow-hidden" style={{ borderRadius: '0.5rem' }}>
                <div
                    className="d-flex flex-column align-items-center justify-content-center py-4"
                    style={{
                        background: 'linear-gradient(135deg, #2d1b4e 0%, #6d28d9 100%)',
                    }}
                >
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle mb-2"
                        style={{
                            width: 72,
                            height: 72,
                            backgroundColor: 'rgba(255,255,255,0.15)',
                        }}
                    >
                        <CheckCircleFill size={44} color="#fff" />
                    </div>
                </div>
                <div className="text-center px-4 pt-4 pb-4">
                    <p className="fw-bold fs-5 mb-1" style={{ color: '#1e1035' }}>{message}</p>
                    <p className="text-muted small mb-4">{t('game_sessions.created_toast_subtitle')}</p>
                    <Button
                        className="px-5 fw-semibold"
                        style={{
                            backgroundColor: '#6d28d9',
                            borderColor: '#6d28d9',
                            borderRadius: '2rem',
                        }}
                        onClick={onClose}>
                        OK
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default SuccessModal;
